import { Expose, Transform, Type } from "class-transformer";
import { DayjsUtils } from "src/libs/dayjs-utils";

function parseInputDateString({ value }): Date | null {
    if (value) {
        return DayjsUtils.getDate(value, true).toDate();
    }
    return null;
}

class MedicineDeliveryRequest {
    @Expose({ name: "fechaCreacion" })
    @Type(() => Date)
    @Transform(parseInputDateString)
    creationDate = new Date();
    @Expose({ name: "numeroDePoliza" })
    policyNumber = "";
    @Expose({ name: "direccionDeEntrega" })
    deliveryAddress = "";
    @Expose({ name: "fechaDeEntrega" })
    @Type(() => Date)
    @Transform(parseInputDateString)
    deliveryDate = new Date();
}

export { MedicineDeliveryRequest };
